/* import __COLOCATED_TEMPLATE__ from './insurance-card.hbs'; */
import { action } from '@ember/object';
import { isImage } from 'client-portal/utils/file';
import { reads } from 'macro-decorators';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';

export default class SharedInsuranceCard extends Component {
  @service fileUpload;
  @service media;
  @service analytics;
  @service store;

  @tracked isMarkedForDeletion = this.args.card?.isMarkedForDeletion;

  @reads('args.side') side;
  @reads('args.card') card;
  @reads('args.insuranceInfoObject') insuranceInfoRequestConnection;
  @reads('card.id') cardId;
  @reads('card.isNew') cardIsNew;
  @reads('card.documentExt') documentExt;
  @reads('card.file.file.type') cardImageType;

  get insuranceInfo() {
    return this.args.insuranceInfo || this.args.client?.primaryInsuranceInfo;
  }

  get isImage() {
    return isImage(this);
  }

  get fileUrl() {
    if (this.cardId && !this.isMarkedForDeletion) {
      let adapter = this.store.adapterFor('insurance-card');
      return adapter.urlForFindRecord(this.cardId, 'insurance-card', {});
    } else if (this.cardIsNew) {
      return URL.createObjectURL(this.card.file.file);
    } else {
      return undefined;
    }
  }

  @action
  removeAssociation() {
    return this.cardIsNew ? this.card.deleteRecord() : this.card.set('isMarkedForDeletion', true);
  }

  @action
  async uploadCard(file) {
    // [#187135093] to add file size validation
    let card = await this.store.createRecord('insurance-card', {
      file,
      insuranceInfo: this.insuranceInfo,
      insuranceInfoRequestConnection: this.insuranceInfoRequestConnection,
    });

    if (this.insuranceInfo) {
      this.insuranceInfo.documents.pushObject(card);
    }

    if (this.insuranceInfoRequestConnection) {
      this.analytics.track('Client Insurance Info Submission Insurance Card Uploaded', {
        object: 'Client Insurance Info Submission Insurance Card',
        action: 'Uploaded',
      });
      this.insuranceInfoRequestConnection.documents.pushObject(card);
    }
  }
}
